import request from '@/utils/request';


// 报告授权请求列表
export function getReportAuthorizeList(params) {
  return request({
	url: '/report/authorize/getToBeAuthorizedReports',
	method: 'GET',
	params
  })
}

// 我的报告列表
export function getMyReportList(params) {
  return request({
	url: '/report/authorize/customerReports',
	method: 'GET',
	params
  })
}

// 其他报告列表
export function getOtherReportList(params) {
  return request({
	url: '/report/authorize/getAuthorizeRecord',
	method: 'GET',
	params
  })
}

// 同意授权
export function agreeAuthorize(params) {
  return request({
	url: '/report/authorize/authorizeReport?reportId='+params,
	method: 'POST'
  })
}

// 拒绝授权
export function refuseAuthorize(params) {
  return request({
	url: '/report/authorize/refuseAuthorize?reportId='+params,
	method: 'POST'
  })
}

// 授权报告
export function reportAuthorize(params) {
  return request({
	url: '/report/authorize/authorizeReport?reportId='+params,
	method: 'POST'
  })
}

// 授权其他公司报告
export function reportAuthorizeOther(params) {
  return request({
	url: '/report/authorize/requestAuthorize?reportNo='+params,
	method: 'POST'
  })
}

// 短信授权其他公司报告
export function reportAuthorizeOtherByMsg(verifyCode,params) {
  return request({
	url: '/report/authorize/verifyCodeAuthorize?verifyCode='+verifyCode+'&reportId='+params,
	method: 'POST'
  })
}

// 报告查看
export function getViewUrl(params) {
  return request({
	url: '/report/authorize/getViewUrl?draftDocumentId='+params,
	method: 'GET'
  })
}
